import { Box, Button } from '@material-ui/core';
import React, { FC } from 'react';

interface Props {
    names: Array<string>
    applyFilter: () => void;
    clearSelectedItem: () => void;
    filterValues: any;
    checkFilter: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckBoxesFilter: FC<Props> = ({
    names,
    applyFilter,
    clearSelectedItem,
    filterValues,
    checkFilter,
}) => {
    return (
        <>
            <div className="filter-dropdown">
                <div className="filter-odds-container">
                    <Box>
                        {names.map((name, i) => {
                            return (

                                <Box key={i} display="flex" alignItems="center">
                                    <input type="checkbox" name={name} checked={filterValues[name]} onChange={checkFilter} />
                                    <div>
                                        {name}
                                    </div>
                                </Box>
                            )
                        })}
                        <Box display="flex" justifyContent="space-evenly" alignItems="center" paddingTop="1em">
                            <Button id="apply-button" onClick={applyFilter}>Filter</Button>
                            <Button id="clear-button" onClick={clearSelectedItem}>Clear</Button>
                        </Box>
                    </Box>
                </div>
            </div>
        </>
    )
}

export default CheckBoxesFilter